document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.our-looks-swiper', {
    slidesPerView: 1,        // how many slides visible
    spaceBetween: 20,        // space between slides in px
    loop: true,              // infinite loop
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {           // responsive settings
      640: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 1,
        spaceBetween: 30
      }
    },
    autoplay: {
      delay: 6000,
      disableOnInteraction: false
    }
  });
});